/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CustomizeAffiliateReferrerCodeOptions,
  CustomizeAffiliateReferrerCodeStatus200,
  CustomizeAffiliateReferrerCodeStatus400,
  CustomizeAffiliateReferrerCodeStatus401,
  CustomizeAffiliateReferrerCodeStatus403,
  CustomizeAffiliateReferrerCodeStatus404,
  CustomizeAffiliateReferrerCodeStatus409,
  CustomizeAffiliateReferrerCodeStatus500,
} from '../types/CustomizeAffiliateReferrerCode'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { customizeAffiliateReferrerCode } from '../clients/customizeAffiliateReferrerCode'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const customizeAffiliateReferrerCodeMutationKey = () =>
  [{ url: '/v1/affiliate_referrers/:referrer_id/code' }] as const

export function customizeAffiliateReferrerCodeMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = customizeAffiliateReferrerCodeMutationKey()
  return mutationOptions<
    CustomizeAffiliateReferrerCodeStatus200,
    ResponseErrorConfig<
      | CustomizeAffiliateReferrerCodeStatus400
      | CustomizeAffiliateReferrerCodeStatus401
      | CustomizeAffiliateReferrerCodeStatus403
      | CustomizeAffiliateReferrerCodeStatus404
      | CustomizeAffiliateReferrerCodeStatus409
      | CustomizeAffiliateReferrerCodeStatus500
    >,
    CustomizeAffiliateReferrerCodeOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return customizeAffiliateReferrerCode({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description The owner of this affiliate membership may change its primary code once. ADMIN callers may change any membership's code repeatedly across tenants. Admin changes preserve the owner's remaining one-time change. Changes are allowed while the program is inactive. Its initial code, whether generated or chosen by an admin, does not count as the change. Previous codes remain aliases and cannot be reused; codes resolve only while the program is active. Codes are unique across all programs and tenants, including for admins.
 * @summary Change an affiliate referral code
 * {@link /v1/affiliate_referrers/:referrer_id/code}
 */
export function useCustomizeAffiliateReferrerCode<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CustomizeAffiliateReferrerCodeStatus200,
      ResponseErrorConfig<
        | CustomizeAffiliateReferrerCodeStatus400
        | CustomizeAffiliateReferrerCodeStatus401
        | CustomizeAffiliateReferrerCodeStatus403
        | CustomizeAffiliateReferrerCodeStatus404
        | CustomizeAffiliateReferrerCodeStatus409
        | CustomizeAffiliateReferrerCodeStatus500
      >,
      CustomizeAffiliateReferrerCodeOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? customizeAffiliateReferrerCodeMutationKey()

  const baseOptions = customizeAffiliateReferrerCodeMutationOptions(config) as UseMutationOptions<
    CustomizeAffiliateReferrerCodeStatus200,
    ResponseErrorConfig<
      | CustomizeAffiliateReferrerCodeStatus400
      | CustomizeAffiliateReferrerCodeStatus401
      | CustomizeAffiliateReferrerCodeStatus403
      | CustomizeAffiliateReferrerCodeStatus404
      | CustomizeAffiliateReferrerCodeStatus409
      | CustomizeAffiliateReferrerCodeStatus500
    >,
    CustomizeAffiliateReferrerCodeOptions,
    TContext
  >

  return useMutation<
    CustomizeAffiliateReferrerCodeStatus200,
    ResponseErrorConfig<
      | CustomizeAffiliateReferrerCodeStatus400
      | CustomizeAffiliateReferrerCodeStatus401
      | CustomizeAffiliateReferrerCodeStatus403
      | CustomizeAffiliateReferrerCodeStatus404
      | CustomizeAffiliateReferrerCodeStatus409
      | CustomizeAffiliateReferrerCodeStatus500
    >,
    CustomizeAffiliateReferrerCodeOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CustomizeAffiliateReferrerCodeStatus200,
    ResponseErrorConfig<
      | CustomizeAffiliateReferrerCodeStatus400
      | CustomizeAffiliateReferrerCodeStatus401
      | CustomizeAffiliateReferrerCodeStatus403
      | CustomizeAffiliateReferrerCodeStatus404
      | CustomizeAffiliateReferrerCodeStatus409
      | CustomizeAffiliateReferrerCodeStatus500
    >,
    CustomizeAffiliateReferrerCodeOptions,
    TContext
  >
}
